import React from 'react'
import styled from 'styled-components'
import images from '../images'

const StyledFooter = styled.div`
    width: 100%;
    text-align: center;
    padding-bottom: 50px;

    @media print {
        display: none;
    }
`

const LogoImg = styled.img`
    height: 88px;
    margin-left: 10px;
`

const Copy = styled.div`
    font-size: 1.45rem;
`

const year = new Date().getFullYear()

export default () => {
    return (
        <StyledFooter>
            <LogoImg src={images.wordPortraitThumb} />
            <Copy>{`© ${year}`}</Copy>
        </StyledFooter>
    )
}


// WEBPACK FOOTER //
// ./src/components/Footer.js